import { IconName, KebabMenu } from '@focaldata/cin-ui-components'
import { QuestionnaireHeaderChip } from '../../HeaderLabels/QuestionnaireHeaderChip'

const LoopingActionsMenuComponent = ({
  sourceEntryPrefix,
  onEditLooping,
  onDisableLooping,
  staticLooping
}: {
  sourceEntryPrefix: string
  onEditLooping: (() => void) | null
  onDisableLooping: () => void
  staticLooping: boolean
}) => {
  return (
    <KebabMenu
      kebabMenuOptions={[
        {
          id: 0,
          textItem: onEditLooping
            ? 'Edit looping'
            : 'Edit looping disabled as source question missing',
          onClickItem: onEditLooping ?? (() => {}),
          disabled: !onEditLooping
        },
        {
          id: 1,
          textItem: 'Disable looping',
          onClickItem: onDisableLooping
        }
      ]}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      menuButton={
        <QuestionnaireHeaderChip iconName={IconName.Repeat}>
          {`${
            staticLooping ? 'Static looping' : 'Looping'
          } based on ${sourceEntryPrefix}`}
        </QuestionnaireHeaderChip>
      }
    />
  )
}

export default LoopingActionsMenuComponent
